function validateEmailReg(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

if (document.querySelector('.input-box-dekaz.email')) {
    
    const inputGroups = document.querySelectorAll('.input-box-dekaz.email')
    const lang = document.documentElement.lang
    let textError = ''
    if (lang === 'es' || lang === 'es-CL') {
        textError = 'Este campo no es un email valido'
      } else {
        textError = 'This field is not a valid email'
      }
    inputGroups.forEach(inputGroup => {
        //   inputGroup  
        const inp = inputGroup.querySelector('input')
        const error = inputGroup.nextElementSibling
        // console.log(inp)
        if (inp) {
            inp.addEventListener('keyup', (e) => {
                // console.log(inp.value)

                if(inp.value === ''  || !validateEmailReg(inp.value)) {
                    error.classList.add('active')
                    inputGroup.classList.add('invalid')
                    error.innerHTML = textError
                } else {
                    error.classList.remove('active')
                    inputGroup.classList.remove('invalid')
                }
            })
        }

    })


}

export function validateEmail(form){
    const inputGroups = form.querySelectorAll('.input-box-dekaz.email')
    let errorEx = false
    if(inputGroups){
    let textError = ''
    const lang = document.documentElement.lang
    if (lang === 'es' || lang === 'es-CL') {
        textError = 'Este campo no es un email valido'
      } else {
        textError = 'This field is not a valid email'
      }
    inputGroups.forEach(inputGroup => {
        //   inputGroup  
        const inp = inputGroup.querySelector('input')
        const error = inputGroup.nextElementSibling
        if(inp.value === ''  || !validateEmailReg(inp.value)) {
            error.classList.add('active')
            inputGroup.classList.add('invalid')
            error.innerHTML = textError
            errorEx = true
        }
    })
    }
    return errorEx
}

// import {validateEmail} from '@/js/components/validation/class/val_email'